import * as vidaTypes from "../types/vida";

const initState = {
  persona: {},
  personSuccess: false,
  idLead: null,
  error: null,
  userData: {},
  status: "",
  leadData: {},
  settingData: {},
  step: 0,
  isNewClient: false,
  experimentStepData: false,
  experimentStepPayment: false,
  experimentQuote: false,
  adviserConfig: {},
  hasTaxObligations: "",
  hasAcceptedExclusions: false,
  suscription: {
    enabled: false,
    caseId: null,
    questions: [],
    answers: {}
  },
};

export default (state = initState, action) => {
  switch (action.type) {
    case vidaTypes.INIT_STATE:
      return {
        ...initState
      }
    case vidaTypes.INIT_SETTING_DATA:
      return {
        ...state,
        settingData: action.data
      };
    case vidaTypes.SAVE_STEP:
      return {
        ...state,
        step: action.data,
      };
    case vidaTypes.SAVE_LEAD_DATA:
      return {
        ...state,
        leadData: action.data,
      };
    case vidaTypes.SAVE_USER_DATA:
      return {
        ...state,
        userData: action.data,
      };
    case vidaTypes.GET_PERSON:
      return {
        ...state,
        persona: action.data,
      };
    case vidaTypes.GET_PERSON_DATA:
      const { persona } = state
      persona['indValidado'] = action.data
      return {
        ...state,
        persona
      }
    case vidaTypes.GET_PERSON_SUCCESS:
      return {
        ...state,
        personSuccess: true,
      };
    case vidaTypes.CLEAN_PERSON:
      return {
        ...state,
        persona: {},
        userData: {},
        personSuccess: false,
      };
    case vidaTypes.SEND_LEAD:
      return {
        ...state,
        idLead: action.data.idLead,
        error: null,
      };
    case vidaTypes.API_ON_ERROR:
      return {
        ...state,
        error: action.data,
        status: "error on api",
        persona: {},
      };
    case vidaTypes.NOT_FOUND_IN_BD:
      return {
        ...state,
        error: action.data,
        status: "not exists on BD",
        persona: {},
      };
    case vidaTypes.CLEAN_STATUS:
      return {
        ...state,
        status: "",
      };
    case vidaTypes.IS_NEW_CLIENT:
      return {
        ...state,
        isNewClient: action.data
      }
    case vidaTypes.EXPERIMENT_STEP_DATA:
      return {
        ...state,
        experimentStepData: action.data
      }
    case vidaTypes.EXPERIMENT_STEP_PAYMENT:
      return {
        ...state,
        experimentStepPayment: action.data
      }
    case vidaTypes.SET_ADVISER_CONFIG:
      return {
        ...state,
        adviserConfig: action.data
      }
    case vidaTypes.SET_EXPERIMENT_QUOTE:
      return {
        ...state,
        experimentQuote: action.data
      }
    case vidaTypes.SET_HAS_TAX_OBLIGATIONS:
      return {
        ...state,
        hasTaxObligations: action.data
      }
    case vidaTypes.SET_HAS_ACCEPTED_EXCLUSIONS:
      return {
        ...state,
        hasAcceptedExclusions: action.data
      }
    case vidaTypes.SET_SUSCRIPTION_CASE_ID:
      return {
        ...state,
        suscription: {
          ...state.suscription,
          caseId: action.data
        }
      }
    case vidaTypes.SET_SUSCRIPTION_QUESTIONS:
      return {
        ...state,
        suscription: {
          ...state.suscription,
          questions: action.data
        }
      }
    case vidaTypes.SET_SUSCRIPTION_ANSWERS:
      return {
        ...state,
        suscription: {
          ...state.suscription,
          answers: action.data
        }
      }
    case vidaTypes.SET_SUSCRIPTION_ENABLED:
      return {
        ...state,
        suscription: {
          ...state.suscription,
          enabled: action.data
        }
      }
    default:
      return state;
  }
};
